export const mockCards = [
  {
    title: '热门韩漫精选',
    subtitle: '恋爱剧情',
    description: '都市情感细腻刻画，画风华丽的韩漫佳作汇聚。从甜蜜校园到职场风云，每部作品都精心挑选，为你带来沉浸式阅读体验。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20korean%20manhwa%20art%20style%2C%20soft%20warm%20lighting%2C%20couple%20silhouette%20against%20sunset%2C%20elegant%20illustration%20with%20delicate%20linework%2C%20pastel%20warm%20tones%2C%20editorial%20quality%2C%20simple%20background%20with%20gentle%20gradient%2C%20modern%20comic%20aesthetic&width=800&height=600&seq=manga-card-01&orientation=landscape',
    tag: '韩漫',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '经典日漫合集',
    subtitle: '热血冒险',
    description: '从王道热血到治愈日常，经典日漫作品全面收录。无论是连载多年的长篇巨制还是口碑炸裂的短篇佳作，这里应有尽有。',
    image: 'https://readdy.ai/api/search-image?query=Action%20japanese%20manga%20illustration%2C%20dynamic%20composition%20with%20warm%20orange%20and%20red%20tones%2C%20epic%20adventure%20scene%2C%20clean%20modern%20art%20style%2C%20soft%20ambient%20light%2C%20simple%20gradient%20background%2C%20professional%20quality%2C%20warm%20atmosphere&width=800&height=600&seq=manga-card-02&orientation=landscape',
    tag: '日漫',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    title: '国漫原创力作',
    subtitle: '古风奇幻',
    description: '国产漫画原创力量崛起，古风仙侠与都市异能并存。优秀的国漫作品持续涌现，带给你独特的东方美学与故事魅力。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20guofeng%20manga%20style%2C%20traditional%20eastern%20elements%2C%20elegant%20ink%20wash%20painting%20influence%2C%20warm%20golden%20and%20earthy%20tones%2C%20flowing%20robes%20and%20ancient%20architecture%2C%20soft%20natural%20lighting%2C%20simple%20elegant%20background&width=800&height=600&seq=manga-card-03&orientation=landscape',
    tag: '国漫',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    title: '新番追更前线',
    subtitle: '每周更新',
    description: '紧跟最新漫画更新节奏，热门连载第一时间同步。不再错过任何精彩章节，虫虫漫画为你守候每一部追更作品的最新动态。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20art%20with%20magical%20elements%2C%20warm%20golden%20and%20amber%20lighting%2C%20ethereal%20atmosphere%2C%20soft%20dreamy%20composition%2C%20enchanting%20illustration%20style%2C%20simple%20warm%20gradient%20background%2C%20modern%20comic%20quality&width=800&height=600&seq=manga-card-04&orientation=landscape',
    tag: '更新',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '完结佳作推荐',
    subtitle: '一口气看完',
    description: '已完结的高分漫画作品一网打尽，从开头到结局完整呈现。不用等待更新的快感，想看的漫画一次追完，畅快淋漓的阅读体验。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20slice%20of%20life%20manga%20illustration%2C%20warm%20cafe%20scene%20with%20soft%20natural%20lighting%2C%20relaxing%20atmosphere%2C%20gentle%20warm%20earth%20tones%2C%20delicate%20linework%2C%20simple%20clean%20background%2C%20peaceful%20composition&width=800&height=600&seq=manga-card-05&orientation=landscape',
    tag: '完结',
    tagColor: 'bg-accent-100 text-accent-700',
  },
];

export const mockTopics = [
  { name: '韩漫', count: 3820, hot: true },
  { name: '日漫', count: 5610, hot: true },
  { name: '国漫', count: 2940, hot: false },
  { name: '热血', count: 1830, hot: true },
  { name: '恋爱', count: 2560, hot: true },
  { name: '奇幻', count: 1470, hot: false },
  { name: '悬疑', count: 980, hot: false },
  { name: '搞笑', count: 1350, hot: false },
  { name: '都市', count: 1720, hot: true },
];

export const mockFeatures = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    description: '独创下拉式阅读模式，无缝浏览漫画内容。翻页流畅不卡顿，给你最舒适的手机与桌面阅读体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日海量更新',
    description: '编辑团队每日精选更新，热门漫画按时同步。追更党福音，不错过任何一部心爱作品的更新动态。',
  },
  {
    icon: 'ri-stack-line',
    title: '20000+ 漫画资源',
    description: '平台收录超过两万部漫画作品，涵盖韩漫日漫国漫等多种类型，分类清晰找漫不费力，总有一部适合你。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '完全免费阅读',
    description: '全站漫画资源完全免费开放，无需付费订阅，无需积分兑换。零门槛享受高品质漫画阅读体验。',
  },
];

export const mockCarouselItems = [
  {
    title: '都市夜话',
    subtitle: '韩漫人气TOP1',
    description: '深夜都市中的爱情故事，画风精美细腻，情节扣人心弦，稳居人气榜首。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20city%20night%20scene%20in%20romantic%20manga%20style%2C%20warm%20neon%20amber%20and%20soft%20pink%20lighting%2C%20couple%20walking%20on%20rainy%20street%2C%20reflective%20wet%20pavement%2C%20cinematic%20composition%2C%20delicate%20illustration%20quality%2C%20atmospheric%20mood&width=1000&height=600&seq=manga-carousel-01&orientation=landscape',
    tag: '韩漫',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '剑与魔法',
    subtitle: '奇幻冒险巨制',
    description: '史诗级奇幻世界观，精美国风绘制，带你进入剑与魔法的传奇旅程。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20illustration%2C%20sword%20and%20magic%20theme%2C%20warm%20golden%20and%20amber%20tones%2C%20hero%20standing%20on%20cliff%20overlooking%20magical%20kingdom%2C%20dramatic%20lighting%2C%20detailed%20linework%2C%20cinematic%20wide%20shot%2C%20simple%20sky%20background&width=1000&height=600&seq=manga-carousel-02&orientation=landscape',
    tag: '国漫',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    title: '校园心动',
    subtitle: '纯爱甜漫首选',
    description: '青涩甜蜜的校园恋爱故事，每一帧都是心动瞬间，甜到让人忍不住微笑。',
    image: 'https://readdy.ai/api/search-image?query=Sweet%20school%20romance%20manga%20scene%2C%20cherry%20blossom%20and%20warm%20spring%20lighting%2C%20young%20couple%20under%20blooming%20tree%2C%20soft%20pastel%20warm%20tones%2C%20gentle%20atmospheric%20composition%2C%20delicate%20illustration%20style&width=1000&height=600&seq=manga-carousel-03&orientation=landscape',
    tag: '恋爱',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    title: '暗夜追踪',
    subtitle: '悬疑推理力作',
    description: '环环相扣的悬疑推理故事，每一个细节都暗藏玄机，烧脑指数爆表。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20noir%20style%2C%20dim%20warm%20lighting%20in%20alley%2C%20detective%20silhouette%2C%20atmospheric%20fog%20and%20shadows%2C%20moody%20amber%20and%20dark%20tones%2C%20cinematic%20composition%2C%20clean%20illustration%20quality&width=1000&height=600&seq=manga-carousel-04&orientation=landscape',
    tag: '悬疑',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '笑林广记',
    subtitle: '爆笑日常系列',
    description: '搞笑漫画天花板，轻松幽默的日常生活，让你笑出腹肌的快乐源泉。',
    image: 'https://readdy.ai/api/search-image?query=Funny%20comedy%20manga%20style%2C%20bright%20warm%20sunny%20scene%2C%20playful%20characters%20in%20everyday%20situation%2C%20expressive%20faces%2C%20cheerful%20golden%20lighting%2C%20simple%20clean%20background%2C%20lighthearted%20atmosphere&width=1000&height=600&seq=manga-carousel-05&orientation=landscape',
    tag: '搞笑',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    title: '异界重生',
    subtitle: '穿越奇幻大作',
    description: '前世今生穿越异界，逆天改命的传奇故事。世界观宏大，剧情张力拉满。',
    image: 'https://readdy.ai/api/search-image?query=Isekai%20fantasy%20manga%20illustration%2C%20portal%20to%20another%20world%2C%20magical%20glowing%20light%2C%20warm%20golden%20and%20emerald%20tones%2C%20adventurer%20facing%20new%20world%2C%20epic%20cinematic%20composition%2C%20clean%20detailed%20art%20style&width=1000&height=600&seq=manga-carousel-06&orientation=landscape',
    tag: '奇幻',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
];

export const mockContact = {
  title: '联系我们',
  description: '有好看的漫画想推荐？有优质的原创作品想投稿？或是有任何使用问题需要反馈？虫虫漫画团队随时欢迎你的来信！我们珍视每一位读者的声音，你的建议是我们不断进步的动力。',
  email: 'contact@chongchongmanga.com',
  qq: '123456789',
  wechat: 'chongchongmanga',
};

export const mockUpdates = [
  { date: '2026-07-28', title: '《都市夜话》第128话更新', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-28', title: '《剑与魔法》第95话上线', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-27', title: '新作《星辰大海》正式上线连载', type: '新作', typeColor: 'bg-accent-100 text-accent-700' },
  { date: '2026-07-27', title: '《校园心动》第204话已更新', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-26', title: '《暗夜追踪》第三季正式开篇', type: '新季', typeColor: 'bg-secondary-100 text-secondary-700' },
  { date: '2026-07-26', title: '韩漫专区新增50部热门作品', type: '入库', typeColor: 'bg-accent-100 text-accent-700' },
  { date: '2026-07-25', title: '《异界重生》第312话更新', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { date: '2026-07-25', title: '阅读体验优化，下拉翻页更流畅', type: '公告', typeColor: 'bg-secondary-100 text-secondary-700' },
];

export const mockMedia = [
  {
    title: '虫虫漫画·热门推荐',
    subtitle: '每周必看漫画清单',
    image: 'https://readdy.ai/api/search-image?query=Manga%20reading%20on%20mobile%20phone%2C%20warm%20cozy%20scene%2C%20person%20holding%20phone%20with%20colorful%20manga%20page%20displayed%2C%20soft%20ambient%20indoor%20lighting%2C%20warm%20wooden%20desk%2C%20minimal%20composition%2C%20aesthetic%20flat%20lay%20style&width=800&height=500&seq=manga-media-01&orientation=landscape',
    duration: '12:35',
  },
  {
    title: '韩漫入坑指南',
    subtitle: '从零开始的韩漫之旅',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20collection%20display%2C%20colorful%20comic%20covers%20arranged%20artistically%2C%20warm%20golden%20lighting%2C%20cozy%20reading%20nook%2C%20minimal%20clean%20background%2C%20aesthetic%20editorial%20photography%20style&width=800&height=500&seq=manga-media-02&orientation=landscape',
    duration: '08:22',
  },
  {
    title: '国漫崛起之路',
    subtitle: '不可错过的国产佳作',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20art%20display%2C%20traditional%20ink%20style%20blended%20with%20modern%20digital%20art%2C%20warm%20earthy%20tones%2C%20elegant%20brushwork%2C%20minimal%20composition%20with%20soft%20natural%20lighting%2C%20editorial%20quality&width=800&height=500&seq=manga-media-03&orientation=landscape',
    duration: '15:40',
  },
  {
    title: '漫画阅读技巧',
    subtitle: '提升阅读体验的小窍门',
    image: 'https://readdy.ai/api/search-image?query=Tablet%20displaying%20manga%20page%20in%20vertical%20scroll%20mode%2C%20warm%20cozy%20reading%20environment%2C%20soft%20lamp%20light%2C%20comfortable%20chair%2C%20minimal%20clean%20interior%2C%20aesthetic%20lifestyle%20photography&width=800&height=500&seq=manga-media-04&orientation=landscape',
    duration: '06:15',
  },
  {
    title: '月度漫画排行榜',
    subtitle: '7月人气榜TOP20速览',
    image: 'https://readdy.ai/api/search-image?query=Manga%20ranking%20chart%20visualization%2C%20colorful%20illustrated%20covers%20in%20grid%2C%20warm%20golden%20accents%2C%20trophy%20and%20star%20elements%2C%20clean%20modern%20design%2C%20minimal%20background%2C%20editorial%20graphic%20style&width=800&height=500&seq=manga-media-05&orientation=landscape',
    duration: '10:50',
  },
];

export const mockIndex = [
  { title: '韩漫大全', count: 3820, description: '最全韩漫资源库，从经典到新番一应俱全', icon: 'ri-heart-pulse-line' },
  { title: '日漫经典', count: 5610, description: '日漫爱好者的天堂，热血治愈应有尽有', icon: 'ri-sword-line' },
  { title: '国漫原创', count: 2940, description: '支持国产原创漫画，发现东方美学魅力', icon: 'ri-brush-line' },
  { title: '恋爱专区', count: 2560, description: '甜到牙疼的恋爱漫画，治愈你的每一天', icon: 'ri-heart-line' },
  { title: '热血格斗', count: 1830, description: '燃到炸裂的战斗场景，唤醒你的热血之魂', icon: 'ri-fire-line' },
  { title: '奇幻冒险', count: 1470, description: '进入异世界的大门，开启奇幻冒险之旅', icon: 'ri-magic-line' },
  { title: '悬疑推理', count: 980, description: '烧脑悬疑不断反转，挑战你的推理能力', icon: 'ri-search-eye-line' },
];

export const mockRanking = [
  { rank: 1, title: '都市夜话', heat: '980万', genre: '韩漫·恋爱', change: 'up' },
  { rank: 2, title: '剑与魔法', heat: '850万', genre: '国漫·奇幻', change: 'up' },
  { rank: 3, title: '校园心动', heat: '760万', genre: '日漫·恋爱', change: 'same' },
  { rank: 4, title: '暗夜追踪', heat: '620万', genre: '韩漫·悬疑', change: 'up' },
  { rank: 5, title: '异界重生', heat: '580万', genre: '国漫·奇幻', change: 'down' },
];

export const mockAbout = {
  title: '关于虫虫漫画',
  paragraphs: [
    '虫虫漫画成立于2024年，是一个专注于漫画阅读的在线平台。我们致力于为漫画爱好者提供最优质、最全面的漫画阅读体验。平台收录超过两万部漫画作品，覆盖韩漫、日漫、国漫等多种类型，支持下拉式在线阅读，让阅读更加流畅自然。',
    '我们的编辑团队每日精选优质漫画内容，确保热门连载作品及时同步更新。无论你是喜欢甜蜜恋爱的少女漫迷，还是热爱热血战斗的少年漫读者，虫虫漫画都能满足你的阅读需求。平台完全免费开放，无需付费即可畅享全部内容。',
    '虫虫漫画始终坚持"让好漫画触手可及"的理念，不断优化阅读体验，扩充漫画资源库。我们相信，好的漫画作品应该被更多人看到，好的故事值得被更多人阅读。感谢每一位读者的支持与陪伴。',
  ],
};

export const mockComments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20student%20portrait%2C%20warm%20friendly%20smile%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20casual%20style%2C%20minimal%20headshot%20photography&width=80&height=80&seq=manga-avatar-01&orientation=squarish',
    name: '漫画迷小王',
    date: '2026-07-27',
    content: '虫虫漫画真的太棒了！下拉式阅读体验特别流畅，比翻页式的舒服太多了。每天通勤路上必刷，推荐了好多韩漫，画风都超好看！',
    likes: 128,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20professional%20woman%20portrait%2C%20warm%20gentle%20expression%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20modern%20casual%20style%2C%20minimal%20headshot%20photography&width=80&height=80&seq=manga-avatar-02&orientation=squarish',
    name: '甜甜的夏天',
    date: '2026-07-26',
    content: '终于找到一个免费又好用的漫画站了！资源超全，更新也快，国漫区也有很多优质原创作品。已经安利给身边所有追漫的小伙伴了～',
    likes: 96,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20male%20college%20student%20portrait%2C%20warm%20friendly%20smile%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20casual%20hoodie%2C%20minimal%20headshot%20photography&width=80&height=80&seq=manga-avatar-03&orientation=squarish',
    name: '追更狂魔阿飞',
    date: '2026-07-25',
    content: '更新速度必须给满分！热门连载基本和原站同步，再也不用到处找资源了。虫虫漫画的收藏功能也很好用，追更列表一目了然。',
    likes: 75,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20creative%20artist%20woman%20portrait%2C%20warm%20artistic%20expression%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20minimal%20headshot%20photography&width=80&height=80&seq=manga-avatar-04&orientation=squarish',
    name: '绘本少女',
    date: '2026-07-24',
    content: '作为一个漫画创作者，看到虫虫漫画对国漫原创的支持真的很感动。平台分类清晰，界面简洁大方，希望越做越好，我也会继续投稿的！',
    likes: 203,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20gamer%20guy%20portrait%2C%20warm%20relaxed%20expression%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20casual%20tshirt%2C%20minimal%20headshot%20photography&width=80&height=80&seq=manga-avatar-05&orientation=squarish',
    name: '摸鱼大师老张',
    date: '2026-07-23',
    content: '上班摸鱼神器！咳咳，说正经的，虫虫漫画的悬疑推理分类真的很全，暗夜追踪系列追得我欲罢不能。全免费这点真的太良心了！',
    likes: 156,
  },
];

export const mockApp = {
  title: '虫虫漫画客户端',
  description: '下载虫虫漫画App，随时随地畅享高清漫画阅读。支持离线下载，无网络也能继续追更。更流畅的下拉式阅读体验，更好的漫画世界在等你！',
  features: ['高清画质阅读', '离线下载缓存', '更新即时推送', '跨设备同步收藏'],
};

export const mockFaq = [
  {
    question: '虫虫漫画是免费的吗？',
    answer: '是的，虫虫漫画平台上的所有漫画内容均为免费阅读。我们致力于让每一位漫画爱好者都能无障碍地享受优质漫画内容，无需付费订阅或积分兑换。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '你可以通过首页的分类导航（韩漫、日漫、国漫等）浏览对应类型，也可以使用搜索功能输入漫画名称或关键词快速查找。热门推荐区和排行榜也能帮你发现精彩作品。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '虫虫漫画编辑团队每日更新漫画内容。热门连载作品会尽量与原始发布平台保持同步更新。你可以关注首页的「最新动态」区域查看每日更新快讯。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是一种流畅的漫画阅读方式。不同于传统的左右翻页模式，你只需向下滑动屏幕即可连续阅读，无需点击翻页按钮。这种模式特别适合手机阅读，让漫画阅读体验更加自然顺畅。',
  },
  {
    question: '可以投稿原创漫画吗？',
    answer: '当然可以！虫虫漫画非常欢迎原创漫画作者投稿。请通过「联系我们」模块中的联系方式与我们取得联系，我们的编辑团队会认真审阅每一份投稿，优秀作品将有机会在平台上展示。',
  },
];

export const mockHeroStats = [
  { label: '收录漫画', value: '20,000+' },
  { label: '每日更新', value: '100+' },
  { label: '全站免费', value: '永久' },
];